import { IconSvgProps } from "@/libraries/wpl/foundations/src/icons/types";

export const OfficeBuildingIcon = ({ size }: IconSvgProps) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 48 49"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g
                id="Brand Icons/Office Building"
                clipPath="url(#clip0_5565_6283)"
            >
                <path
                    id="Vector"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.999 40.5V8.5H35.999V40.5H26.9995V33.5H20.9995V40.5H11.999ZM17.999 15.5H21.999V12.5H17.999V15.5ZM25.999 15.5H29.999V12.5H25.999V15.5ZM21.999 22.5H17.999V19.5H21.999V22.5ZM17.999 29.5H21.999V26.5H17.999V29.5ZM29.999 22.5H25.999V19.5H29.999V22.5ZM25.999 29.5H29.999V26.5H25.999V29.5Z"
                    fill="#101214"
                />
            </g>
            <defs>
                <clipPath id="clip0_5565_6283">
                    <rect
                        width="48"
                        height="48"
                        fill="white"
                        transform="translate(-0.000976562 0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
